export const apiStatuses = {
  SUCCESS: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  NOT_ACCEPTABLE: 406,
  CONFLICT: 409,
  SERVER_ERROR: 500,
};

export const responseTypes = {
  INFORMATIONAL: '1',
  SUCCESS: '2',
  REDIRECT: '3',
  CLIENT_ERROR: '4',
  SERVER_ERROR: '5',
};
